import { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../../hooks/useWindowSize";
import SvgIcon from "../../SvgIcon";

export const CommentInput = ({
  isMealPhotos,
  handleSubmitComment,
  typingComment,
  setTypingComment,
}) => {
  const { t } = useTranslation("common");
  const textareaRef = useRef(null);
  const submitButtonRef = useRef(null);
  const formRef = useRef(null);
  const windowSize = useWindowSize();
  const isMobile = windowSize.innerWidth < 768;

  const handleInput = () => {
    const el = textareaRef.current;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;

    if (el.scrollHeight > 120) {
      el.style.height = "120px";
    }

    el.scrollTo({
      top: el.scrollHeight,
    });
  };

  useEffect(() => {
    if (submitButtonRef?.current) {
      submitButtonRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      formRef?.current?.requestSubmit();
    }
  };

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      textareaRef.current.style.height = "auto";
      setTimeout(() => {
        submitButtonRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
      }, 300);
      handleSubmitComment(e);
    },
    [handleSubmitComment]
  );

  return (
    <form className="thread-comment-form" onSubmit={onSubmit} ref={formRef}>
      <textarea
        name="thread-comment"
        id="thread-comment"
        className="thread-comment-input"
        placeholder={t("threadComments.inputPlaceholder")}
        value={typingComment}
        onChange={(e) => setTypingComment(e.target.value)}
        onInput={handleInput}
        ref={textareaRef}
        rows={1}
        onKeyDown={handleKeyDown}
        autoFocus={isMealPhotos ? false : true}
      />
      {isMealPhotos || isMobile ? (
        <button
          type="submit"
          role="button"
          ref={submitButtonRef}
          data-button-type="primary"
          disabled={typingComment.length === 0}
          sz="large"
        >
          <SvgIcon src={"/img/new-icons/send.svg"} noFilterOnLight={true} />
        </button>
      ) : (
        <button
          type="submit"
          role="button"
          data-button-type="primary"
          disabled={typingComment.length === 0}
          ref={submitButtonRef}
        >
          {t("threadComments.submit")}
        </button>
      )}
    </form>
  );
};
